import { render, staticRenderFns } from "./CreativeInsight.vue?vue&type=template&id=5595a2ef&"
import script from "./CreativeInsight.vue?vue&type=script&lang=js&"
export * from "./CreativeInsight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports